import * as React from 'react';
import noop from 'lodash/noop';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import DeliverableCustomContext from '../context/DeliverableCustomContext';

import { __t, applyTranslations } from 'utils/language';

import type {
  DeliverableCustomContext as DeliverableCustomContextType
} from 'types';

import './deliverable-custom-gallery-asset-overlay.scss';

applyTranslations(require('../deliverable-custom.i18n.json'));

const MSG_KEY = 'deliverable_custom';

const DeliverableCustomGalleryAssetOverlay = (
  selectedItem,
  items
): React.ReactNode => {
  const currentItem = items.find(item => selectedItem.id === item.id);

  const handleSelectionChange = (
    context: DeliverableCustomContextType | null,
    event: React.MouseEvent
  ): void => {
    const callback = context?.onSelectionChange || noop;

    callback(!currentItem.isSelected, selectedItem, event);
  };

  return (
    <DeliverableCustomContext.Consumer key={currentItem.id}>
      {(context) => (
        <div className="deliverable-custom-gallery-asset-overlay">
          <div
            className="deliverable-custom-gallery-asset-overlay__footer"
            onClick={(event) => handleSelectionChange(context, event)}
          >
            <InputCheckbox
              key={`deliverable-custom-gallery-asset-overlay__checkbox--${currentItem.id}`}
              id={`deliverable-custom-gallery-asset-overlay__checkbox--${currentItem.id}`}
              name="deliverable-custom-gallery-asset-overlay__checkbox"
              value={String(!!currentItem.isSelected)}
              checked={!!currentItem.isSelected}
              label={__t(`${MSG_KEY}.gallery_modal.select_item`, {
                mediaType: currentItem.assetType || currentItem.mediaType
              })}
              labelClass="deliverable-custom-gallery-asset-overlay__label"
            />
          </div>
        </div>
      )}
    </DeliverableCustomContext.Consumer>
  );
};

export default DeliverableCustomGalleryAssetOverlay;
